import { Resources } from 'constants/resources';

import { Fragment } from 'react';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { MethodLogosDeleteDialog } from 'pages/MethodLogos/components/MethodLogosDeleteDialog/MethodLogosDeleteDialog';
import { MethodLogosFilters } from 'pages/MethodLogos/MethodLogosFilters';
import { CreateButton } from 'shared/mui/Buttons';
import {
  ContextMenu,
  ContextMenuDeleteButton,
  ContextMenuEditButton,
  ContextMenuEntityUserActionsButton,
  ContextMenuShowButton,
} from 'shared/mui/ContextMenu';
import { ExportButton } from 'shared/react-admin/Buttons';
import { DateTimeField, TextField, WrapperField } from 'shared/react-admin/Fields';
import { TooltipTextLinkField } from 'shared/react-admin/Fields/TooltipTextLinkField/TooltipTextLinkField';
import { ListPage } from 'shared/react-admin/Pages/ListPage/ListPage';
import { MethodLogo } from 'types/embedded/methodLogo';
import { Permission } from 'types/embedded/permission';

import { DatagridStyled, ImageFieldStyled } from './MethodLogosList.styled';

export const MethodLogosList: React.FC = () => {
  const { hasResourcePermissions, hasResourceAccess } = usePermissions();
  const { record, handleOpenRecordModal, openRecordModal, handleCloseRecordModal } =
    useRecordModal<MethodLogo>();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.MethodLogos, [Permission.Full, Permission.Create]) && (
          <CreateButton key="create_method_logos" />
        ),
        <ExportButton key="export_method_logos" />,
      ]}
      empty={false}
      headerTitle={{
        titleText: 'Логотипы методов',
      }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <MethodLogosFilters />
      <DatagridStyled bulkActionButtons={false}>
        <TextField label="ID" sortBy="id" source="originId" />
        <TooltipTextLinkField label="Название" resource="method_logos" source="name" type="show" />
        <WrapperField>
          <Fragment />
        </WrapperField>
        <ImageFieldStyled label="Логотип" sortable={false} source="filePath" />
        <DateTimeField label="Дата создания" source="createdAt" />
        <DateTimeField label="Дата редактир." source="updatedAt" />
        <ContextMenu
          render={(record: MethodLogo) => [
            hasResourceAccess(Resources.UserActions) && (
              <ContextMenuEntityUserActionsButton
                entityName="method_logo"
                key="user-action-button"
              />
            ),
            <ContextMenuShowButton key="show-button" />,
            hasResourcePermissions(Resources.MethodLogos, [Permission.Full, Permission.Update]) && (
              <ContextMenuEditButton key="edit-button" />
            ),
            hasResourcePermissions(Resources.MethodLogos, [Permission.Full, Permission.Delete]) && (
              <ContextMenuDeleteButton
                key="delete-button"
                onClick={() => handleOpenRecordModal(record)}
              />
            ),
          ]}
        />
      </DatagridStyled>
      {openRecordModal && (
        <MethodLogosDeleteDialog
          onClose={handleCloseRecordModal}
          open={openRecordModal}
          record={record}
        />
      )}
    </ListPage>
  );
};
